export default __webpack_public_path__ + "static/media/teacher.56ab20fa.png";